import { colors } from 'styles/colors';
import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 3rem 0;
  background: ${colors.seaDark};
`;

export const Details = styled.div`
  color: #e7ecef;
  font-size: 1rem;
  line-height: 1.6;

  p {
    margin-bottom: 0.25rem;
  }

  a {
    color: inherit;
    text-decoration: underline;
  }
`;
